import * as React from "react";
import { useHistory } from "react-router";

import { URLS, useSocialCoachSession } from "@/utils";
import { Button, Card } from "@/components/ui";
import { Png, Svg } from "@/assets";
import { ConfigContext } from "@/contexts/appContexts";

const IntegratedFirstCongrats: React.FC = () => {
  const history = useHistory();
  const { refreshSession } = useSocialCoachSession();
  const config = React.useContext(ConfigContext);

  const handleFinish = () => {
    refreshSession().then(() => history.push(URLS.player.dashboard));
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-120px)] sm:min-h-[calc(100vh-200px)] p-4 sm:p-6 text-slate-900">
      <Card className="w-full max-w-[500px] p-0 overflow-hidden border-none shadow-2xl">
        <div className="p-8 sm:p-12 flex flex-col items-center text-center">
          <div className="flex justify-center mb-8">
            <img src={Png.Logo} alt="SocialCoach" className="w-48 sm:w-60" />
          </div>
          <div className="text-lg sm:text-3xl font-bold mb-2">You're all set!</div>
          <div className="text-sm sm:text-base">
            Your profile is ready. Now it's time to build your presence and start posting.
          </div>
        </div>

        <div className="px-16 flex flex-col items-center bg-white">
          <Card className="w-full bg-slate-50/50 border-slate-100 p-6 flex flex-col items-center">
            <p className="text-sm text-slate-500 text-center mb-6 max-w-sm">
              Download our mobile app to receive notifications, record videos, and post to your social accounts with one
              tap.
            </p>

            <div className="flex flex-row items-center justify-center gap-4 w-full px-4">
              <a
                href={config.iOSUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform hover:scale-105 active:scale-95 flex-1 max-w-[140px]"
              >
                <img src={Svg.AppStore} alt="App Store" className="w-full h-auto" />
              </a>
              <a
                href={config.androidUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform hover:scale-105 active:scale-95 flex-1 max-w-[140px]"
              >
                <img src={Svg.PlayStore} alt="Play Store" className="w-full h-auto" />
              </a>
            </div>
          </Card>
        </div>
        <div className="flex flex-col items-center m-8">
          <Button className="w-full h-12 text-base" onClick={handleFinish}>
            Let's get started
          </Button>
        </div>
      </Card>
    </div>
  );
};

export const FirstCongratsPage = IntegratedFirstCongrats;
